export enum Places {
  MAP_V3 = 'mapV3',
  MAP_V2 = 'mapV2',
  RENTAL_MAP = 'rentalMap',
  PUBLIC_LAYOUT = 'publicLayout',
  DEFAULT_LAYOUT = 'defaultLayout',
}
